import React from 'react'
import dot from "../images/dott.svg";

export const Dots = () => {
  return (
    <div className="flex">
      <div className="opacity-50">
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2 " src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
      </div>
      <div className="opacity-50">
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
      </div>
      <div className="opacity-50">
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
      </div>
      <div className="opacity-50">
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
      </div>
      <div className="opacity-50">
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
        <img className="p-2" src={dot} alt="dot" />
      </div>
    </div>
  );
}

export const Dot = () => {
    return (
      <div className='flex'>
        <div className="opacity-50">
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2 " src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
        </div>
        <div className="opacity-50">
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
        </div>
        <div className="opacity-50">
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
          <img className="p-2" src={dot} alt="dot" />
        </div>
      </div>
    );
}
